import RestProvider from "providers/RestProvider";
import { cruds, texts } from "./SolicitarContrasenaData";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { properties } from "./SolicitarContrasenaData";

const useFunctions = () => {
  const { crudOperation, crudOperationsType } = RestProvider();
  const history = useHistory();
  const [message, setMessage] = useState({ msg: "", severity: "" });
  let _ID = 0;
  const addAlert = (msg) => setAlerts([...alerts, { id: _ID++, msg }]);
  const [alerts, setAlerts] = useState([]);
  const handleSetMessage = (msg, severity) => {
    setMessage({ msg, severity });
    addAlert(message);
  };
  const [isLoading, setIsLoading] = useState(false);
  const irAccesoConContrasena = () => { history.push("/AccesoConContrasena") }
  const cerrarAviso = () => { setMostrarConfirmacion(false) }
  const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false);
  const [mensajeConfirmacion, setMensajeConfirmacion] = useState('');
  const [imageConfirmacion, setImageConfirmacion] = useState(properties.IMAGEN_OK);
  const [accionConfirmacion, setAccionConfirmacion] = useState(() => irAccesoConContrasena);
  

/**
 * @function handleOnSubmit Función que se ejecutará cuando se produzca en el formulario el evento onSubmit
 */
const handleOnSubmit = async (data) => {
  setIsLoading(true);
  
  await crudOperation(crudOperationsType.CUSTOM, cruds.loginRequest.resource, {
    url: cruds.loginRequest.url,
    method: "post",
    data: {email: data.data.correoElectronico},
  })
  .then(() => {
    setMensajeConfirmacion(texts.confirmacion.mensaje_a
      + data.data.correoElectronico 
      + texts.confirmacion.mensaje_b)
    setImageConfirmacion(properties.IMAGEN_OK)
    setAccionConfirmacion(() => irAccesoConContrasena)
    setIsLoading(false)
    setMostrarConfirmacion(true)
  })
  .catch(function  (error) {
    if (error.response && error.response.status === 404) {
      setMensajeConfirmacion("El correo  <b>" + data.data.correoElectronico + "</b>  no está asignado a ningún usuario.")
      setImageConfirmacion(properties.IMAGEN_ERROR)      
      setAccionConfirmacion(() => cerrarAviso)
      setMostrarConfirmacion(true)
    } else {
      // En caso de otros errores, manejar según sea necesario
      handleSetMessage("Error al solicitar la restauración", "error")
    }
    setIsLoading(false)
  })

};

  /**
   * @function handleCustomEvents Función que captura los eventos de los botones customizados
   * @param {*} customEvent
   */
  const handleCustomEvents = (customEvent) => {
    // Captura cuando se hace click sobre el botón Atrás
    if (customEvent.type === "btnAtras") {
      history.push('/AccesoConContrasena');
    }
  };

  return {
    handleOnSubmit,
    handleCustomEvents,
    isLoading,
    alerts,
    message,
    setMessage,
    irAccesoConContrasena,
    mostrarConfirmacion,
    mensajeConfirmacion,
    imageConfirmacion,
    accionConfirmacion
  };
};

export default useFunctions;
